import { signInWithRedirect } from "@aws-amplify/auth";
import { Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import { publicPaths } from "../../../routes";
import { checkboxGap, perelynLightRed, smallGap } from "../../../styles/consts";
import { BiggerIcon } from "./Icon";

export default function MicrosoftButton() {
  const location = useLocation();
  const provider = { custom: "AzureAD" };

  function handleSignInClick() {
    const currentParams = new URLSearchParams(location.search);
    const navigateAfterLogin = currentParams.get("navigateAfterLogin");

    if (navigateAfterLogin) {
      localStorage.setItem("navigateAfterLogin", navigateAfterLogin);
    } else {
      const currentPath = location.pathname;
      if (!publicPaths.includes(currentPath)) {
        localStorage.setItem("navigateAfterLogin", currentPath);
      }
    }
    signInWithRedirect({ provider });
  }

  return (
    <Button
      variant="outlined"
      onClick={handleSignInClick}
      sx={{
        "&&": {
          width: "100%",
        },
        fontSize: "1rem",
        gap: checkboxGap,
        padding: `1.35rem ${smallGap}`,
        ":hover": {
          "&&": {
            backgroundColor: perelynLightRed,
            "& > *": { filter: "none" },
          },
        },
      }}
    >
      <BiggerIcon name="Microsoft" />
      Sign in with Microsoft
    </Button>
  );
}
